import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { logoutApi } from 'redux/actions/UserLogout';
import { drawerWidthEnum } from 'utils/enumObj';
import { companyDetails } from 'utils/companyDetails';
import { getBranding } from 'config/tenantConfig';
import { adminSidebar, commonSideData } from './SideData';

function SideNav(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = localStorage.getItem('role');
  const [filteredData, setFilteredData] = useState([]);
  const location = useLocation();
  const { window, handleDrawerOpen, onlyMobile, onMobileOpen } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState();

  const userSideNavData = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions,
  );

  //func for to compare result array with sidenav array
  function findCommonElement(array1, array2) {
    const resultArr = [];
    // Loop for array1
    for (let i = 0; i < array1.length; i++) {
      for (let j = 0; j < array2.length; j++) {
        if (array1[i].keyword === array2[j].moduleKey) {
          let id = array1[i];
          if (array1[i].submenu?.length && array2[j].subModule?.length) {
            let resArr = [];
            for (let k = 0; k < array1[i].submenu?.length; k++) {
              for (let l = 0; l < array2[j].subModule?.length; l++) {
                if (array1[i]?.submenu[k]?.keyword === array2[j]?.subModule[l]?.moduleKey) {
                  resArr.push(array1[i]?.submenu[k]);
                }
              }
            }
            id.submenu = [];
            id.submenu = resArr;
            resultArr.push(id);
          } else {
            resultArr.push(array1[i]);
          }
        }
      }
    }

    // Return if no common element exist
    return resultArr;
  }

  useEffect(() => {
    if (Array.isArray(userSideNavData) && userSideNavData.length > 0) {
      const parentModuleResult = findCommonElement(adminSidebar, userSideNavData);
      setFilteredData(parentModuleResult);
    }
  }, [userSideNavData]); // Dependency array

  const sidenavData = [...filteredData, ...commonSideData];

  const [drawerSize, setDrawerSize] = useState(drawerWidthEnum.maxWidth);
  const [dropdownOpenStates, setDropdownOpenStates] = useState(
    Array(sidenavData.length).fill(false),
  );

  //handle function for toggling dropdown
  const toggleDropdown = (index) => {
    const updatedStates = [...dropdownOpenStates];
    updatedStates[index] = !updatedStates[index];
    setDropdownOpenStates(updatedStates);
  };

  //handle function for toggling dropdown
  const handleDrawerToggle = () => {
    handleDrawerOpen();
    setMobileOpen(!mobileOpen);
    setDesktopOpen(!desktopOpen);
    if (drawerSize === drawerWidthEnum.maxWidth) {
      setDrawerSize(drawerWidthEnum.minWidth);
    } else {
      setDrawerSize(drawerWidthEnum.maxWidth);
    }
  };

  const handleListItemClick = (menu, index) => {
    if (menu?.field === 'Logout') {
      dispatch(logoutApi());
    } else {
      const updatedStates = Array(sidenavData.length).fill(false);
      if (menu?.subIndex) {
        updatedStates[index] = true;
      }
      setDropdownOpenStates(updatedStates);
      localStorage.setItem('sidenavIndex', JSON.stringify(updatedStates));
    }
    if (onlyMobile) {
      onMobileOpen(false);
    }
  };

  const handelOnlyMobileDev = () => {
    onMobileOpen();
    setDrawerSize(drawerWidthEnum.maxWidth);
  };

  const [activeTab, setActiveTab] = useState(null);

  const splittedLocation = location.pathname.split('/');
  const subMenu = splittedLocation?.[2];

  const operationData = [
    'allrides',
    'allot',
    'dispatch',
    'billing',
    'payment',
    'booking',
    'corporatecustomer',
    'revenue',
    'mis',
    'allotvehicle',
    'allotdriver',
    'addcomplaince',
    'addcab',
    'addfeedback',
    'faq',
    'tollCharges',
    'taxConfiguration',
  ];

  useEffect(() => {
    if (operationData.includes(subMenu)) {
      setActiveTab(splittedLocation[2]);
    } else if (role === 'operation') {
      setActiveTab(splittedLocation[2]);
    } else {
      setActiveTab(splittedLocation[1]);
    }
  }, [location.pathname]);

  useEffect(() => {
    const dropdownValues =
      localStorage?.getItem('sidenavIndex') && JSON.parse(localStorage?.getItem('sidenavIndex'));
    if (dropdownValues?.length && splittedLocation?.[2]) {
      setDropdownOpenStates(dropdownValues);
    } else {
      setDropdownOpenStates(Array(sidenavData.length).fill(false));
    }
  }, []);

  const drawer = (
    <div className="sidebarStyle">
      <Toolbar className="pl20">
        <IconButton
          aria-label="open drawer"
          edge="start"
          onClick={onlyMobile ? handelOnlyMobileDev : handleDrawerToggle}
          md={{ mr: 2, display: { sm: 'block' } }}
          className="pl25"
        >
          <MenuIcon className="iconColor" />
        </IconButton>
        {desktopOpen && (
          <img
            className="logoImage"
            src={getBranding().logo || companyDetails?.companyLogo}
            alt="CompanyLogo"
          />
        )}
      </Toolbar>
      <List className="listStyle">
        {sidenavData?.map((sideData, index) => {
          if (sideData?.submenu) {
            const isDropdownOpen = dropdownOpenStates[index];
            return (
              <div key={sideData.id}>
                <ListItemButton
                  className={`${
                    activeTab === sideData?.path?.split('/')[1]
                      ? 'activeSideNavStyle'
                      : 'sideNavStyle'
                  } ${desktopOpen ? 'paddingExpand' : 'paddingCollapse'}`}
                  selected={activeTab === sideData?.path?.split('/')[1]}
                  onClick={() => toggleDropdown(index)}
                >
                  <ListItemIcon className="sideNavIcon">
                    {activeTab === sideData?.path?.split('/')[1] ? (
                      <img src={sideData?.activeIcon} alt="ActiveIcons" />
                    ) : (
                      <img src={sideData?.icon} alt="DashboardIcons" />
                    )}
                  </ListItemIcon>
                  {desktopOpen && <ListItemText primary={sideData.field} />}
                  {isDropdownOpen ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
                </ListItemButton>
                <Collapse in={isDropdownOpen} timeout="auto" unmountOnExit className="collapseBg">
                  <List component="div" disablePadding>
                    {sideData.submenu.map((submenuItem, id) => (
                      <ListItemButton
                        key={submenuItem.id}
                        className={`sidenavDrop ${
                          activeTab === submenuItem?.path?.split('/')[1]
                            ? 'activeSubmenu'
                            : 'sidenavDrop'
                        } ${desktopOpen ? 'paddingExpand' : 'paddingCollapse'} `}
                        onClick={() => handleListItemClick(submenuItem, index)}
                        component={Link}
                        to={
                          submenuItem?.path === 'operation/allrides'
                            ? `/${submenuItem.path}/all`
                            : submenuItem?.path === 'operation/billing'
                              ? `/${submenuItem.path}/billToCompany`
                              : `/${submenuItem.path}`
                        }
                      >
                        <ListItemIcon className="sideNavIcon">
                          {activeTab === submenuItem?.path?.split('/')[1] ? (
                            <img src={submenuItem.activeIcon} alt="ActiveIcons" />
                          ) : (
                            <img src={submenuItem.icon} alt="DashboardIcons" />
                          )}
                        </ListItemIcon>
                        {desktopOpen && <ListItemText primary={submenuItem.field} />}
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </div>
            );
          } else if (sideData.field === 'Logout') {
            return (
              <ListItem
                name={sideData.field}
                key={sideData.id}
                className="sideNavStyle cursorPointer"
                onClick={(event) => handleListItemClick(sideData)}
              >
                <ListItemIcon className="sideNavIcon">
                  {selectedIndex === sideData.id ? (
                    <img src={sideData.activeIcon} alt="ActiveIcons" />
                  ) : (
                    <img src={sideData.icon} alt="DashboardIcons" />
                  )}
                </ListItemIcon>
                {desktopOpen && <ListItemText className="listIconStyle" primary={sideData.field} />}
              </ListItem>
            );
          } else {
            return (
              <ListItem
                name={sideData.field}
                key={sideData.id}
                className={`${
                  activeTab ===
                  (role !== 'operation'
                    ? sideData?.path?.split('/')[0]
                    : sideData?.path?.split('/')[1])
                    ? 'activeSideNavStyle'
                    : 'sideNavStyle'
                } ${desktopOpen ? 'paddingExpand' : 'paddingCollapse'}`}
                onClick={(event) => handleListItemClick(sideData)}
                component={Link}
                to={sideData.path === 'compliance' ? `/${sideData.path}/2` : `/${sideData.path}`}
              >
                <ListItemIcon className="sideNavIcon">
                  {activeTab ===
                  (role !== 'operation'
                    ? sideData?.path?.split('/')[0]
                    : sideData?.path?.split('/')[1]) ? (
                    <img src={sideData.activeIcon} alt="ActiveIcons" />
                  ) : (
                    <img src={sideData.icon} alt="DashboardIcons" />
                  )}
                </ListItemIcon>
                {desktopOpen && <ListItemText className="listIconStyle" primary={sideData.field} />}
              </ListItem>
            );
          }
        })}
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box className="dflex">
      <Box
        component="nav"
        md={{
          width: { sm: drawerWidthEnum.maxWidth },
          flexShrink: { sm: 0 },
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={onlyMobile}
          onClose={handelOnlyMobileDev}
          ModalProps={{
            keepMounted: true,
          }}
          className="customDrawer"
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              width: drawerWidthEnum.maxWidth,
            },
            '& .MuiBackdrop-root': {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          open={desktopOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          className="customDrawer"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              width: drawerSize,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

export default SideNav;
